import { combineReducers } from "redux";
import auth from "./auth/reducer";
import device from "./device/reducer"
import wishlistReducer from './wishlistSlice';
import cartReducer from './cartSlice';
export default combineReducers({
  wishlist: wishlistReducer, 
  auth,
  cart: cartReducer,
  device,
});
